export default __webpack_public_path__ + "recordJob.html";